module.exports = require("./ru.d.ts");